class Cedexis {
  constructor(config) {
    const s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://radar.cedexis.com/1/22393/radar.js';
    const x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x);
  }
}

export default Cedexis;



// WEBPACK FOOTER //
// ./src/services/cedexis.js